<template>
  <span>
      <el-form-item label="1-9月利润：" class="query-form-item">
          <el-input style="width: 70px;" clearable v-model="query.min_early_profit"
                    placeholder="最小" size="mini"></el-input>
          -
          <el-input style="width: 70px;" clearable v-model="query.max_early_profit"
                    placeholder="最大" size="mini"></el-input>
      </el-form-item>

      <el-form-item label="利润率(含税)(%):" class="query-form-item">
          <el-input-number style="width: 110px;" clearable v-model="query.min_profit_rate"
                           placeholder="最小" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
          -
          <el-input-number style="width: 110px;" clearable v-model="query.max_profit_rate"
                           placeholder="最大" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
      </el-form-item>

      <el-form-item label="1-9月投资回报率(%):" class="query-form-item">
          <el-input-number style="width: 110px;" clearable v-model="query.min_early_investment_return_rate"
                           placeholder="最小" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
          -
          <el-input-number style="width: 110px;" clearable v-model="query.max_early_investment_return_rate"
                           placeholder="最大" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
      </el-form-item>
  </span>
</template>

<script>
    export default {
        name: 'formRangeItem',
        props: ['queryTemp'],
        watch: {
            'queryTemp': {
                handler(val) {
                    this.query = val
                },
                immediate: true,
                deep: true
            }
        },
        data() {
            return {
                query: {}
            }
        },
        methods: {
            handleQueryData() {
                let tempQuery = JSON.parse(JSON.stringify(this.query))

                if (tempQuery.min_profit_rate !== null) {
                    tempQuery.min_profit_rate = tempQuery.min_profit_rate == 0 ? 0 : tempQuery.min_profit_rate / 100
                }
                if (tempQuery.max_profit_rate !== null) {
                    tempQuery.max_profit_rate = tempQuery.max_profit_rate == 0 ? 0 : tempQuery.max_profit_rate / 100
                }
                if (tempQuery.min_early_investment_return_rate !== null) {
                    tempQuery.min_early_investment_return_rate = tempQuery.min_early_investment_return_rate == 0 ? 0 : tempQuery.min_early_investment_return_rate / 100
                }
                if (tempQuery.max_early_investment_return_rate !== null) {
                    tempQuery.max_early_investment_return_rate = tempQuery.max_early_investment_return_rate == 0 ? 0 : tempQuery.max_early_investment_return_rate / 100
                }
                return tempQuery
            }
        }
    }
</script>

